// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-granth-registration-ledger-indetail-officer-report',
//   standalone: true,
//   imports: [],
  // templateUrl: './granth-registration-ledger-indetail-officer-report.component.html',
  // styleUrl: './granth-registration-ledger-indetail-officer-report.component.scss'
// })
// export class GranthRegistrationLedgerIndetailOfficerReportComponent {

// }
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-granth-registration-ledger-indetail-officer-report',
   templateUrl: './granth-registration-ledger-indetail-officer-report.component.html',
  styleUrl: './granth-registration-ledger-indetail-officer-report.component.scss'
})
export class GranthRegistrationLedgerIndetailOfficerReportComponent {

  groupedData: any[] = [];
    currentDate = new Date();
  
    startDate: any;
    endDate: any;
    reportType: any;
    repName: any;
    officeRepName: any;
    bookName: any;
    bookSellerName: any;
  
    // GRAND TOTALS
    grandSaleCopies = 0;
    grandRetCopies = 0;
    grandCompCopies = 0;
    grandAmount = 0;
    grandReceived = 0;
    grandCredit = 0;
    grandRemaining = 0;
    grandCommission = 0;
    selectedCommissionFilter: string[] = [];
  selectedComplimentaryFilter: string[] = [];
  
    constructor(
      private dialogRef: MatDialogRef<GranthRegistrationLedgerIndetailOfficerReportComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService
    ) {}
  
    ngOnInit(): void {
      debugger
      this.startDate = this.data?.startDate;
      this.endDate = this.data?.endDate;
      this.reportType = this.data?.reportType;
      this.repName = this.data?.rep_name;
      this.officeRepName = this.data?.office_rep_name;
      this.bookName = this.data?.book_name;
      this.bookSellerName = this.data?.book_seller_name;
        this.selectedCommissionFilter = this.data?.commissionFilter || [];
          this.selectedComplimentaryFilter = this.data?.complimentaryFilter || [];
  
      this.getLedgerReport();
    }
  
    // ================= FETCH DATA =================
    getLedgerReport() {
  
      const req = {
        start_date: this.startDate,
        end_date: this.endDate,
        rep_name: this.repName,
        office_rep_name: this.officeRepName,
        book_name: this.bookName,
        book_seller_name: this.bookSellerName,
         commissionFilter: this.selectedCommissionFilter,
              complimentaryFilter: this.selectedComplimentaryFilter
      };
  
      this.service.getgranthRegistrationLedgerReport2(req).subscribe({
        next: (res: any) => {
          if (res?.success) {
            this.prepareBookwiseData(res.data);
          }
        },
        error: err => console.error('API Error:', err)
      });
    }
  
    // ================= BOOKWISE TOTAL CALCULATION =================
   prepareBookwiseData(data: any[]) {
  
    this.groupedData = [];
  
    // RESET GRAND TOTALS
    this.grandSaleCopies = 0;
    this.grandRetCopies = 0;
    this.grandCompCopies = 0;
    this.grandAmount = 0;
    this.grandReceived = 0;
    this.grandCredit = 0;
    this.grandRemaining = 0;
    this.grandCommission = 0;
  
    data.forEach(book => {
  
      let saleCopies = 0;
      let returnCopies = 0;
      let compCopies = 0;
      let totalAmount = 0;
      let received = 0;
      let credit = 0;
      let remaining = 0;
      let commission = 0;
  
      book.records.forEach((r: any) => {
  
        saleCopies += Number(r.sale_copies || 0);
        returnCopies += Number(r.return_copies || 0);
        compCopies += Number(r.complimentary_copies || 0);
  
        // ✅ TOTAL AMOUNT = TOTAL + SHIPPING
        const baseTotal = Number(r.total || 0);
        const shipping  = Number(r.shipping_charges || 0);
        const finalTotal = baseTotal + shipping;
  
        // store calculated value in row itself
        r.calculated_total = finalTotal;
  
        totalAmount += finalTotal;
  
        received += Number(r.received_amt || 0);
        credit += Number(r.credit_amt || 0);
        remaining += Number(r.remaining_amt || 0);
        commission += Number(r.rep_commission_amt || 0);
      });
  
      this.groupedData.push({
        book_name: book.book_name,
        records: book.records,
        saleCopies,
        returnCopies,
        compCopies,
        totalAmount,
        totalReceived: received,
        totalCredit: credit,
        totalRemaining: remaining,
        totalCommission: commission
      });
  
      // GRAND TOTALS
      this.grandSaleCopies += saleCopies;
      this.grandRetCopies += returnCopies;
      this.grandCompCopies += compCopies;
      this.grandAmount += totalAmount;
      this.grandReceived += received;
      this.grandCredit += credit;
      this.grandRemaining += remaining;
      this.grandCommission += commission;
    });
  }
  
  
    // ================= PRINT =================
printPage(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=900,height=1200');

  WindowPrt!.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Book Credit Note Report</title>
        <style>

          /* ===== ENSURE COLORS & BORDERS PRINT ===== */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          /* ===== A4 PORTRAIT PAGE ===== */
          @page {
            size: A4 portrait;
            margin: 8mm 6mm 8mm 15mm; /* top right bottom left */
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 11px;
            color: #000;
            -webkit-font-smoothing: none;
          }

          /* ===== TABLE ===== */
          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #000;   /* outer border */
          }

          th, td {
            border: 1px solid #000;
            padding: 5px 6px;
            vertical-align: middle;
            white-space: nowrap;
            text-align: left;
          }

          thead {
            display: table-header-group;
          }

          tr {
            page-break-inside: avoid;
          }

          /* ===== FOOTER ===== */
          tfoot {
            display: table-row-group;
            font-weight: bold;
          }

          /* ===== PRINT ONLY ===== */
          @media print {
            .noPrint { display: none !important; }
          }

        </style>
      </head>

      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  WindowPrt!.document.close();
  WindowPrt!.focus();

  setTimeout(() => {
    WindowPrt!.print();
    WindowPrt!.close();
  }, 500);
}

  
  
  
    // ================= EXPORT EXCEL =================
    exportExcel(name: string) {
      const table = document.getElementById('print-section')!;
      const ws = XLSX.utils.table_to_sheet(table);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Report');
      XLSX.writeFile(wb, `${name}.xlsx`);
    }
  }
  